import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import Button from "@material-ui/core/Button";
import {
  ROUTE_ADMIN_LIBOR,
  ROUTE_ADMIN_COMPANIES,
  ROUTE_ADMIN_CONTACTS,
  ROUTE_ADMIN_TEST_HARNESS,
  ROUTE_ADMIN_COMPANY_CREDIT_RATINGS,
  ROUTE_ADMIN_CAP_CALCULATOR_SETTINGS,
  ROUTE_ADMIN_SUP_CALCULATOR_SETTINGS,
  ROUTE_ADMIN_GUEST_PERMISSIONS,
  ROUTE_ADMIN_GUEST_INDIVIDUAL_SETTINGS,
  ROUTE_ADMIN_GUEST_METRICS,
  ROUTE_ADMIN_LOAN_PROCEED_SETTINGS,
  ROUTE_ADMIN_CASH_OUT_PROCEEDS_LOAN_PROCEEDS_SETTINGS,
  ROUTE_ADMIN_CASH_OUT_PROCEEDS_LOAN_PROCEEDS_RUN_TABLE,
  ROUTE_ADMIN_GUEST_GROUP,
  ROUTE_ADMIN_FINACIAL_REPORTING,
  ROUTE_ADMIN_API_TEST,
  ROUTE_ADMIN_VENDOR_INTEGRATIONS,
  ROUTE_ADMIN_COMPANY_SPONSORS,
  ROUTE_ADMIN_HOLIDAY_CALENDAR,
  ROUTE_ADMIN_CASHFLOW_TEST_HARNESS,
  ROUTE_ADMIN_APPS_SETTINGS,
  ROUTE_ADMIN_DOMO_REPORT
} from "constants/routes";
import PrivateRoute from "components/PrivateRoute";
import applicationRoles from "constants/applicationRoles";
import ArrowLeftIcon from "lib/ui/arrowLeft";
import Styles from "./styles";
import Libor from "./Libor/";
import TestHarness from "./TestHarness";
import Contacts from "./Contacts/";
// eslint-disable-next-line import/no-named-as-default
import Companies from "./Companies/";
import CompanyCreditRatings from "./CompanyCreditRatings";
import CapCalculatorSettings from "./CapCalculatorSettings";
import ManageGuestGroupPage from "./Guest/util/ManageGuestGroupPage";
import GuestPermissionsPage from "./Guest/List";
import GuestIndividualSettingsPage from "./Guest/util/GuestIndividualSettingsPage";
import GuestMetricPage from "./Guest/util/GuestMetricsPage";
import LoanProceedSettingsPage from "./loanProceedSettingsPage";
import supCalculatorSettingsPage from "./supCalculatorSettingsPage";
import financialReporting from "./ConfigItems/FinancialReporting";
import APITestHarness from "./ApiTestHarness";
import VendorIntegrationsPage from "./VendorIntegrations";
import CompanySponsors from "./CompanySponsors";
import { LoanProceedsSettings } from './CashOutProceeds';
import { LoanProceedsRunTable } from './LoanProceedsRunTable';
import HolidayCalendar from './HolidayCalendar/index';
import CashflowTestHarness from './Cashflows/index';
import AppsSettings from "./AppsSettings"
import DomoReport from './DomoReport/index';
import { isAppsAdmin } from "../../store/state/auth";

class Admin extends Component {
  state = {
    error: false
  };

  componentDidMount() {
    if (this.isAuthorized([applicationRoles.SYSTEMADMIN])) {
      this.props.isAppsAdmin();
    }
  }

  handle_GoBack = e => {
    e.preventDefault();
    this.props.history.goBack();
  };

  isAuthorized(authArray) {
    for (let index = 0; index < authArray.length; index++) {
      const auth = authArray[index];
      if (this.props.authentication.user.roles.includes(auth)) return true;
    }
    return false;
  }
  buildNavLink = (route, label, authArray) => {
    if (this.isAuthorized(authArray))
      return (
        <NavLink exact to={route}>
          <Button>{label}</Button>
        </NavLink>
      );
  };

  render() {
    return (
      <>
        <Styles>
          <div className="dialogInner_PersonalSettings">
            <header>
              System Settings
              <Button onClick={this.handle_GoBack} className="button_closePersonalSettings">
                <ArrowLeftIcon />
              </Button>
            </header>

            <section>
              <nav>
                {this.buildNavLink("/admin/libor", "LIBOR Upload", [applicationRoles.SYSTEMADMIN])}
                {this.buildNavLink("/admin/contacts", "Users", [applicationRoles.SYSTEMADMIN, applicationRoles.COMPANYADMIN])}
                {this.buildNavLink("/admin/companies", "Companies", [applicationRoles.SYSTEMADMIN])}
                {this.buildNavLink("/admin/testHarness", "Test Harness", [applicationRoles.SYSTEMADMIN])}
                {this.buildNavLink("/admin/companyCreditRatings", "Hedge Provider Ratings", [applicationRoles.SYSTEMADMIN])}
                {this.buildNavLink("/admin/capCalculatorSettings", "Cap Calculator Settings", [applicationRoles.SYSTEMADMIN])}
                {this.buildNavLink("/admin/supCalculatorSettings", "Supp Calculator Settings", [applicationRoles.SYSTEMADMIN])}
                {this.buildNavLink("/admin/guestPermissions", "Guest Permissions", [applicationRoles.SYSTEMADMIN, applicationRoles.COMPANYADMIN])}
                {this.buildNavLink("/admin/guestMetrics", "Guest Metrics", [applicationRoles.SYSTEMADMIN, applicationRoles.COMPANYADMIN])}
                {this.buildNavLink(ROUTE_ADMIN_CASH_OUT_PROCEEDS_LOAN_PROCEEDS_SETTINGS, 'Loan Proceeds Settings', [applicationRoles.SYSTEMADMIN, applicationRoles.COMPANYADMIN])}
                {this.buildNavLink("/admin/loanProceedSettings", "Loan Proceeds", [applicationRoles.SYSTEMADMIN, applicationRoles.COMPANYADMIN])}
                {this.buildNavLink(ROUTE_ADMIN_CASH_OUT_PROCEEDS_LOAN_PROCEEDS_RUN_TABLE, 'Loan Proceeds Run Table', [applicationRoles.SYSTEMADMIN, applicationRoles.COMPANYADMIN])}
                {this.buildNavLink("/admin/financialReporting", "Financial Reporting", [applicationRoles.SYSTEMADMIN])}
                {this.buildNavLink("/admin/apiTest", "API Test Harness", [applicationRoles.SYSTEMADMIN])}
                {this.buildNavLink("/admin/vendorIntegrations", "Lender Compliance Settings", [applicationRoles.SYSTEMADMIN, applicationRoles.COMPANYADMIN])}
                {this.buildNavLink("/admin/companySponsors", "Broker Company Settings", [applicationRoles.SYSTEMADMIN])}
                {this.buildNavLink("/admin/holidayCalendarSettings", "Holiday Calendar", [applicationRoles.SYSTEMADMIN])}
                {this.buildNavLink(ROUTE_ADMIN_CASHFLOW_TEST_HARNESS, "Cashflows", [applicationRoles.SYSTEMADMIN])}
                {this.props.authentication.isAppsAdmin &&
                  this.buildNavLink(ROUTE_ADMIN_APPS_SETTINGS, "Apps Settings", [applicationRoles.SYSTEMADMIN])
                }
                {this.buildNavLink("/admin/domoReportSettings", "Domo Report Settings", [applicationRoles.SYSTEMADMIN])}
              </nav>
              <main className="main">
                <PrivateRoute systemAdmin authentication={this.props.authentication} path={ROUTE_ADMIN_LIBOR} Component={Libor} />
                <PrivateRoute systemAdmin companyAdmin authentication={this.props.authentication} path={ROUTE_ADMIN_CONTACTS} Component={Contacts} />
                <PrivateRoute systemAdmin authentication={this.props.authentication} path={ROUTE_ADMIN_COMPANIES} Component={Companies} />
                <PrivateRoute systemAdmin authentication={this.props.authentication} path={ROUTE_ADMIN_COMPANY_SPONSORS} Component={CompanySponsors} />
                <PrivateRoute systemAdmin authentication={this.props.authentication} path={ROUTE_ADMIN_HOLIDAY_CALENDAR} Component={HolidayCalendar} />
                <PrivateRoute systemAdmin authentication={this.props.authentication} path={ROUTE_ADMIN_CASHFLOW_TEST_HARNESS} Component={CashflowTestHarness} />
                <PrivateRoute systemAdmin authentication={this.props.authentication} path={ROUTE_ADMIN_DOMO_REPORT} Component={DomoReport} />

                <PrivateRoute systemAdmin authentication={this.props.authentication} path={ROUTE_ADMIN_TEST_HARNESS} Component={TestHarness} />

                <PrivateRoute
                  systemAdmin
                  authentication={this.props.authentication}
                  path={ROUTE_ADMIN_COMPANY_CREDIT_RATINGS}
                  Component={CompanyCreditRatings}
                />
                <PrivateRoute
                  systemAdmin
                  authentication={this.props.authentication}
                  path={ROUTE_ADMIN_CAP_CALCULATOR_SETTINGS}
                  Component={CapCalculatorSettings}
                />
                <PrivateRoute
                  systemAdmin
                  authentication={this.props.authentication}
                  path={ROUTE_ADMIN_SUP_CALCULATOR_SETTINGS}
                  Component={supCalculatorSettingsPage}
                />
                <PrivateRoute systemAdmin authentication={this.props.authentication} path={ROUTE_ADMIN_FINACIAL_REPORTING} Component={financialReporting} />
                <PrivateRoute
                  systemAdmin
                  companyAdmin
                  authentication={this.props.authentication}
                  path={ROUTE_ADMIN_LOAN_PROCEED_SETTINGS}
                  Component={LoanProceedSettingsPage}
                />
                <PrivateRoute systemAdmin authentication={this.props.authentication} path={ROUTE_ADMIN_API_TEST} Component={APITestHarness} />
                <PrivateRoute
                  systemAdmin
                  companyAdmin
                  authentication={this.props.authentication}
                  path={ROUTE_ADMIN_CASH_OUT_PROCEEDS_LOAN_PROCEEDS_SETTINGS}
                  Component={LoanProceedsSettings}
                />
                <PrivateRoute
                  systemAdmin
                  companyAdmin
                  authentication={this.props.authentication}
                  path={ROUTE_ADMIN_CASH_OUT_PROCEEDS_LOAN_PROCEEDS_RUN_TABLE}
                  Component={LoanProceedsRunTable}
                />
                <PrivateRoute
                  systemAdmin
                  companyAdmin
                  authentication={this.props.authentication}
                  path={ROUTE_ADMIN_GUEST_PERMISSIONS}
                  Component={GuestPermissionsPage}
                />
                <PrivateRoute
                  systemAdmin
                  companyAdmin
                  authentication={this.props.authentication}
                  path={ROUTE_ADMIN_GUEST_GROUP}
                  Component={ManageGuestGroupPage}
                />
                <PrivateRoute
                  systemAdmin
                  companyAdmin
                  authentication={this.props.authentication}
                  path={ROUTE_ADMIN_GUEST_INDIVIDUAL_SETTINGS}
                  Component={GuestIndividualSettingsPage}
                />
                <PrivateRoute
                  systemAdmin
                  companyAdmin
                  authentication={this.props.authentication}
                  path={ROUTE_ADMIN_GUEST_METRICS}
                  Component={GuestMetricPage}
                />
                <PrivateRoute
                  systemAdmin
                  companyAdmin
                  authentication={this.props.authentication}
                  path={ROUTE_ADMIN_VENDOR_INTEGRATIONS}
                  Component={VendorIntegrationsPage}
                />
                <PrivateRoute
                  systemAdmin
                  authentication={this.props.authentication}
                  path={ROUTE_ADMIN_APPS_SETTINGS}
                  Component={AppsSettings}
                />
              </main>
            </section>
          </div>
        </Styles>
      </>
    );
  }
}

const mapStateToProps = ({ authentication }) => ({
  authentication
});

export default connect(mapStateToProps, { isAppsAdmin })(Admin);
